import { TablePagination } from "@/components/Pagination/TablePagination"
import { ExchangeFilter } from "@/components/Transactions/Exchange/ExchangeFilter"
import { ExchangeList } from "@/components/Transactions/Exchange/List"
import { useTransactions } from "@usher/pe-client-front-end-lib"

const TYPE = "Buy"
const PER_PAGE = 5

export const TransactionsExchangeTypeBuy = () => {
  const { data, isLoading, isInitialized, onFilter, dataTotal, pageCount, pageIndex, setPageIndex } = useTransactions({
    type: TYPE,
    pageSize: PER_PAGE,
  })
  return (
    <>
      <ExchangeFilter onFilter={onFilter} type={TYPE} />
      <ExchangeList loading={isLoading} type={TYPE} orders={data} isInitialized={isInitialized} />
      <TablePagination dataTotal={dataTotal} currentPage={pageIndex} totalPages={pageCount} onPageChange={setPageIndex} />
    </>
  )
}
